import styled from '@emotion/styled'

const DividerStyles = styled('hr')(({ theme: { colors } }) => ({
  border: '0',
  height: '1px',
  background: colors.greymid,
}))

export default DividerStyles
